const DmtkWS = {
  install(Vue, options) {
    /*
		WebSocket Wrapper
	*/

    let ws = false;
    let $ws = false;
    let errors = 0;
    let reconnect = false;

    const hooks = {
      _: {},
      add(hook, fn) {
        if (!hooks._.hasOwnProperty(hook)) {
          hooks._[hook] = [];
        }
        hooks._[hook].push(fn);
      },
      execute(hook, payload) {
        if (!hooks._.hasOwnProperty(hook)) {
          return;
        }
        hooks._[hook].map((fn) => fn(payload));
      },
    };

    $ws = {
      opened() {
        return ws.readyState === WebSocket.OPEN;
      },
      on: (event, callback) => {
        hooks.add(event, callback);
      },
      $on: (payload) => {
        let message;
        try {
          message = JSON.parse(payload.data);
        } catch (e) {
          //console.log(e, payload);
          return;
        }
        hooks.execute(message.event, message.data);
      },
      emit: (event, data) => {
        if (!$ws.opened()) {
          console.error('Error al emitir: No conectado', event, data);
          return;
        }
        ws.send(
          JSON.stringify({
            event,
            data,
          }),
        );
      },
    };

    /*
	  WebSocket
	*/

    function connect() {
      //console.log('$ws.connect');
      ws = new WebSocket('wss://' + location.host);
      ws.onopen = () => {
        clearTimeout(reconnect);
        //console.log('$ws.onopen', arguments);
        hooks.execute('open', arguments);
      };
      ws.onclose = () => {
        //console.log('$ws.onclose', arguments);
        if (++errors < 33) {
          //console.log('$ws.reconnect', arguments);
          reconnect = setTimeout(connect, 3000);
          hooks.execute('close', arguments);
        }
      };
      ws.onerror = () => {
        console.error('Ha sucedido un error :(');
      };
      ws.onmessage = $ws.$on;

      setInterval(() => {
        //console.log('ws.ping');
        ws.send('ping');
      }, 30000);
    }

    /*
        Assignment
	*/

    connect();
    Vue.prototype.$ws = $ws;
  },
};
